import "./styles.scss";

import React, { useLayoutEffect, useRef, useState } from "react";
import clsx from "clsx";

import Social from "components/Social";

import { getColorVariant } from "utils";

import { clinicsData } from "data/clinics";

const Clinics = () => {
  return (
    <div className="footer-clinics">
      <div className="footer-clinics__header">
        <h4>Nasze poradnie</h4>
        <Social />
      </div>
      <div className="footer-clinics__list">
        {clinicsData.map((clinic, index) => (
          <Row
            key={index}
            name={clinic?.name}
            street={clinic?.location?.street}
            city={clinic?.location?.city}
            phones={clinic?.contact?.phones}
            emails={clinic?.contact?.emails}
            variant={getColorVariant(index + 1)}
          />
        ))}
      </div>
    </div>
  );
};

const Row = ({ name, street, city, phones, emails, variant }) => {
  const [underlineWidth, setUnderlineWidth] = useState(0);

  const rowRef = useRef(null);
  const nameRef = useRef(null);

  useLayoutEffect(() => {
    const name = nameRef.current;

    if (name) {
      setUnderlineWidth(name.clientWidth);
    }
  }, []);

  const handleUnderlineWidth = (width) =>
    width ? setUnderlineWidth(width) : undefined;

  if (!name) return null;

  return (
    <div
      ref={rowRef}
      className={clsx(
        "footer-clinics__list-row",
        variant && `footer-clinics__list-row--${variant}`
      )}
      style={{ "--underline-width": underlineWidth + "px" }}
      role="presentation"
      onMouseEnter={() => handleUnderlineWidth(rowRef.current?.clientWidth)}
      onMouseLeave={() => handleUnderlineWidth(nameRef.current?.clientWidth)}
    >
      <div className="row">
        <div className="col-md-4 col-lg-3 d-flex flex-column align-items-start">
          <p ref={nameRef}>{name}</p>
        </div>
        <div className="col-md-3 col-lg-2">{street && <p>{street}</p>}</div>
        <div className="col-md-5 col-lg-2">{city && <p>{city}</p>}</div>
        <div className="col-md-7 col-lg-2">
          {phones && (
            <ul>
              {phones.map((phone, index) => (
                <li key={index}>
                  <a href={`tel:+48${phone.replaceAll(" ", "")}`}>{phone}</a>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="col-md-5 col-lg-3">
          {emails && (
            <ul>
              {emails.map((email, index) => (
                <li key={index}>
                  <a href={`mailto:${email}`}>{email}</a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Clinics;
